import { useAuth } from '../context/AuthContext';
import { useCallback } from 'react';

/**
 * useAuthFetch – custom hook that returns a fetch wrapper that automatically 
 * attaches the admin token when the current user is an admin.
 *
 * @returns {(url: string, options?: RequestInit, overrideToken?: string|null) => Promise<Response>}
 */
export const useAuthFetch = () => {
  const { auth } = useAuth();
  
  const authFetch = useCallback(async (url, options = {}, overrideToken = null) => {
    const token = overrideToken !== null ? overrideToken : auth.adminToken;
    const headers = new Headers(options.headers || {});
    if (token) {
      headers.set('x-admin-token', token);
    }
    return fetch(url, { ...options, headers });
  }, [auth.adminToken]);

  return authFetch;
};
